module.exports = __webpack_public_path__ + "static/media/spiring_grey.4eaa8e78.svg";